// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accordion_wrapper__QQi84","item":"accordion_item__tZILh"};